import { FOLLOW_UP_FORM, FOLLOW_UP_DROPDOWN } from "./type";

const initalState = {
  followUpDropDown: {},
  followUpSuccess: {},
};

const followUpFormReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case FOLLOW_UP_DROPDOWN:
      return {
        ...state,
        followUpDropDown: payload,
      };
    case FOLLOW_UP_FORM:
      return {
        ...state,
        followUpSuccess: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default followUpFormReducer;
